// extracted by mini-css-extract-plugin
module.exports = {"container":"internalLinks_container__3m0h6"};